import { API_URL } from "../constants";
import Leaflet from 'leaflet';

export const fetchGeometries = (areaproperties) => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    let body = JSON.stringify(areaproperties);

    return fetch(API_URL + "/geometries/", {headers, method: "POST", body})
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
      .then(res => {
        if (res.status === 200) {
          const geometries = {
            type: 'FeatureCollection',
            features:
               (res.data).map(segment =>({
                  'type':'Feature',
                  'geometry': JSON.parse(segment.json),
                  'properties': {
                     'name': segment.name,
                     'code': segment.code,
                     'type': segment.type,
                     'geometrytype': areaproperties['geometrytype']
                    }
               })
            )
          }

          return dispatch({type: 'FETCH_GEOMETRIES', areaproperties: areaproperties, geometries: geometries});
        }         
      })
  }
}

export const redrawGeoJSON = () => {
  return (dispatch, getState) => {
    dispatch({type: 'REDRAW_GEOJSON'});
    return Promise.resolve(true);
  }
}

export const selectAreaData = (areaproperties) => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};

    const layers = getState().objects.layers;
    const activescenarioindex = getState().selector.scenarios;
    const map = getState().map;
    const visiblelayers = [];

    if (activescenarioindex !== null) {
      let activescenarioid = getState().objects.scenarios[activescenarioindex].id;
      for(var i = 0; i < layers.length; i++) {
        if ((layers[i].visible) && (parseInt(layers[i].scenario) === parseInt(activescenarioid))) {
          visiblelayers.push(layers[i].id);
        }
      }
    }

    let body = JSON.stringify({periodstart: map.periodstart, periodend: map.periodend, area: areaproperties.code, layers: visiblelayers});

    return fetch(API_URL + "/areadata/", {headers, method: "POST", body})
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
      .then(res => {
        if (res.status === 200) {
          return dispatch({type: 'SELECT_AREA_DATA', areaproperties: areaproperties, data: res.data.data});
        } else if (res.status === 401 || res.status === 403) {
          dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
          throw res.data;
        }
      })
  }
}

export const zoomToArea = (areacode) => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    let body = JSON.stringify({areacode: areacode});

    return fetch(API_URL + "/geometrybounds/", {headers, method: "POST", body})
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
      .then(res => {
        if (res.status === 200) {
          const map = getState().global.map;   
          if (map === null) return;

          const southWest = [res.data.rect[1], res.data.rect[0]]
          const northEast = [res.data.rect[3], res.data.rect[2]]
          map.fitBounds([southWest, northEast], {animate: false});
        } 
      })
  }
}

export const gotoLocation = (location) => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};

    return fetch(API_URL + "/locationposition?location=" + encodeURIComponent(location), {headers, method: "GET"})
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
      .then(res => {
        if (res.status === 200) {
          const { map } = getState().global;

          if (res.data.result === 'success') {
            map.flyTo({lng: res.data.data.lng, lat: res.data.data.lat}, res.data.data.zoom, {animate: false});
          }
        }
      })
  }
}


